// extracted by mini-css-extract-plugin
module.exports = {"root":"layout_root__JrdRn"};